import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { IHistoryRecord, IObjectNameIdentifier } from "../../../../documaker/domain/format/objects";

export interface INameHistoriesPropertyEditable {
  nameHistories(): IPropertyEditable<IHistoryRecord<IObjectNameIdentifier>[]>;
}

export function instanceOfINameHistoriesPropertyEditable(instance: any): instance is INameHistoriesPropertyEditable {
  return instance
      && instance.nameHistories
      && instanceOfIPropertyEditable<IHistoryRecord<IObjectNameIdentifier>[]>(instance.name());
}
